// extracted by mini-css-extract-plugin
module.exports = {"slickPrev":"Slider_slickPrev__dm5An","slickNext":"Slider_slickNext__38xLO"};